module.exports = __webpack_public_path__ + "static/media/9-apr16sep16.9abd5e82.pdf";